<template>
  <div>
    <v-row :class="`d-flex justify-center ma-2`">
      <PieChart
        :dark="dark"
        v-if="data != null"
        :chart-data="this.datasets"
        :options="this.options"
        :color1="this.color"
        :height="this.height"
        :width="this.width"
      ></PieChart>
    </v-row>
    <v-row :class="`d-flex justify-center`">
      <template v-if="this.value[0] != null">
        <v-chip
          class="ma-2"
          rounded="pill"
          dense
          dark
          :color="dark ? this.legendColors[0] : this.legendColors[1]"
          elevation="6"
          outlined
        >
          <b>{{ this.label[0] }}: {{ this.value[0] }}</b>
        </v-chip>
      </template>

      <template v-if="this.value[1] != null">
        <v-chip
          class="ma-2"
          rounded="pill"
          dense
          dark
          :color="dark ? this.legendColors[3] : this.legendColors[4]"
          elevation="6"
          outlined
        >
          <b> {{ this.label[1] }}: {{ this.value[1] }}</b>
        </v-chip>
      </template>
      <template v-if="this.value[2] != null">
        <v-chip
          class="ma-2"
          rounded="pill"
          dense
          dark
          :color="dark ? this.legendColors[6] : this.legendColors[7]"
          elevation="6"
          outlined
        >
          <b> {{ this.label[2] }}: {{ this.value[2] }}</b>
        </v-chip>
      </template>

      <template v-if="this.value[3] != null">
        <v-chip
          class="ma-2"
          rounded="pill"
          dense
          dark
          :color="dark ? this.legendColors[9] : this.legendColors[10]"
          elevation="6"
          outlined
        >
          <b> {{ this.label[3] }}: {{ this.value[3] }}</b>
        </v-chip>
      </template>
    </v-row>
  </div>
</template>

<script>
import PieChart from "./core/PieChart.vue";
import { customColors } from "../../colors.js";

export default {
  name: "AnyPieChart",
  components: { PieChart },
  props: {
    dark: {
      type: Boolean,
      required: false,
    },
    label: {
      type: Array,
    },
    value: {
      type: Array,
    },
    data: {
      type: Array,
      required: true,
    },
    color: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    customColors: customColors,
    legendColors: [],
    datasets: {
      datasets: [
        {
          data: 0,
        },
      ],
    },

    options: {
      /*       tooltips: {
        mode: "label",
        callbacks: {
          label: function(tooltipItem, data) {
            return (
              data.labels[tooltipItem.index] +
              ": " +
              data.datasets[0].data[tooltipItem.index] +
              " k"
            );
          },
        },
      }, */

      tooltips: {
        enabled: false,

        callbacks: {
          label: (tooltipItems, data) => {
            return (
              data.datasets[tooltipItems.datasetIndex].data[
                tooltipItems.index
              ] +
              this.label[tooltipItems.index] +
              "kW"
            );
          },
        },
      },

      legend: {
        display: false,
        position: "top",
        labels: {
          fontColor: "#111",
        },
      },
      animation: {
        animateRotate: false,
        animateScale: false,
      },
      responsive: false,
      maintainAspectRatio: true,
    },
  }),
  mounted() {
    this.changeValues();
    this.changeColor();
  },
  methods: {
    changeValues() {
      this.legendColors = this.color;

      if (this.dark === false) {
        for (let index = 0; index < this.legendColors.length; index++) {
          if (
            this.legendColors[index] == this.customColors.light.toBattery[1]
          ) {
            this.$set(
              this.legendColors,
              index,
              this.customColors.light.toBattery[0]
            );
          }
          if (this.legendColors[index] == this.customColors.light.toGrid[1]) {
            this.$set(
              this.legendColors,
              index,
              this.customColors.light.toGrid[0]
            );
          }
        }
      }

      this.datasets = {
        datasets: [
          {
            data: this.data,
          },
        ],
      };
    },
    changeColor() {
      this.legendColors = this.color;

      if (this.dark === false) {
        for (let index = 0; index < this.legendColors.length; index++) {
          if (
            this.legendColors[index] == this.customColors.light.toBattery[1]
          ) {
            this.$set(
              this.legendColors,
              index,
              this.customColors.light.toBattery[0]
            );
          }
          if (this.legendColors[index] == this.customColors.light.toGrid[1]) {
            this.$set(
              this.legendColors,
              index,
              this.customColors.light.toGrid[0]
            );
          }
        }
      }

      if (this.dark === true) {
        this.options.legend = {
          display: true,
          position: "top",
          labels: {
            fontColor: "#FFFFFF",
          },
        };
      } else {
        this.options.legend = {
          display: true,
          position: "top",
          labels: {
            fontColor: "#000000",
          },
        };
      }
    },
  },
  watch: {
    data: function() {
      this.changeValues();
    },
    dark: function() {
      this.changeColor();
    },
  },
};
</script>

<style scoped>
.v-icon {
  text-shadow: 20px 20px 10px rgba(0, 0, 0, 0.5);
}
</style>
